import gamescom from '../../../../common/img/gamescom-banner/gamecom.svg';
import background from '../../../../common/img/gamescom-banner/background.svg';
import { StyledButton } from '../../../../common/Styleguide/Common/Button';
import styled from '@emotion/styled';
import { fromZonedTime } from 'date-fns-tz';

const CONTACT_LINK =
  'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0KM1KvCV72i9EUWDZ8RwXq4eQmym_K6ZwmAtNCqZ26QLnwzHcdcGVzGVVw4HDRX_lBjQ02eV0Q';

export function shouldShowGamesComBanner() {
  if (window.location.href.includes('http://localhost:3001')) {
    return true;
  }

  const currentTime = new Date();

  const endDate = fromZonedTime('2025-08-24T23:59:59Z', 'CET');

  return currentTime <= endDate;
}

const StyledGamesComBanner = styled('div')({
  '@media (max-width: 1300px)': {
    display: 'none',
  },
  height: `100px`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 36,
  background: `linear-gradient(90deg, #240057 30%, #1F2847 100%)`,
});

export const GamesComBanner: React.FC = () => {
  return (
    <StyledGamesComBanner>
      <img src={background} style={{ position: 'absolute' }} alt="Background" />
      <div style={{ fontWeight: 900, fontSize: 31, zIndex: 1 }}>Meet us at</div>
      <img src={gamescom} style={{ height: 53, marginTop: 10, zIndex: 1 }} alt="Gamescom" />
      <div style={{ height: 37, backgroundColor: 'white', width: 2, zIndex: 1 }}></div>
      <div style={{ fontWeight: 500, fontSize: 25, color: '#85FFC2', zIndex: 1 }}>Koln 20-24 August 2025</div>
      <StyledButton color="white" variant="contained" height={48} style={{ zIndex: 1 }} onClick={() => window.open(CONTACT_LINK, '_blank')}>
        Schedule a meeting here
      </StyledButton>
    </StyledGamesComBanner>
  );
};
